import React from 'react';

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);
